import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Layout/Loader";
import PrivateLaunchLogin from "./Login/PrivateLaunchLogin";
import { loadUser } from "../redux/actions/user";
import { server } from "../server";
import { clearAuthSession, getStoredAuthToken } from "../utils/authSession";
import { setStoredCurrentProfile } from "../utils/shopProfile";
import {
  isPrivateLaunchModeEnabled,
  isPrivateLaunchPublicPath,
  isPrivateLaunchSuperAdmin,
} from "../utils/privateLaunchAccess";

const getCurrentPathname = () => {
  if (typeof window === "undefined") {
    return "/";
  }

  return window.location.pathname || "/";
};

const getCurrentSearch = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return window.location.search || "";
};

const PrivateLaunchGate = ({ children }) => {
  const dispatch = useDispatch();
  const logoutAttemptedRef = useRef(false);
  const loadAttemptedRef = useRef(false);
  const { loading, isAuthenticated, user } = useSelector((state) => state.user);
  const privateLaunchEnabled = isPrivateLaunchModeEnabled();
  const hasStoredToken = Boolean(getStoredAuthToken());
  const currentPathname = getCurrentPathname();
  const currentSearch = getCurrentSearch();

  useEffect(() => {
    if (!privateLaunchEnabled || loadAttemptedRef.current || !hasStoredToken || user) {
      return;
    }

    loadAttemptedRef.current = true;
    dispatch(loadUser());
  }, [dispatch, hasStoredToken, privateLaunchEnabled, user]);

  useEffect(() => {
    if (
      !privateLaunchEnabled ||
      loading !== false ||
      !isAuthenticated ||
      !user ||
      isPrivateLaunchSuperAdmin(user) ||
      logoutAttemptedRef.current
    ) {
      return;
    }

    logoutAttemptedRef.current = true;
    clearAuthSession();
    setStoredCurrentProfile("User");
    dispatch({
      type: "LoadUserFail",
      payload: {
        message: "Private launch access is limited.",
        isAuthFailure: true,
      },
    });

    axios.post(`${server}/user/logout`, {}, { withCredentials: true }).catch(() => {});
  }, [dispatch, isAuthenticated, loading, privateLaunchEnabled, user]);

  if (!privateLaunchEnabled) {
    return children;
  }

  if (isAuthenticated && user && isPrivateLaunchSuperAdmin(user)) {
    return children;
  }

  if (isPrivateLaunchPublicPath(currentPathname, currentSearch)) {
    return children;
  }

  if (hasStoredToken && loading !== false) {
    return <Loader />;
  }

  return <PrivateLaunchLogin />;
};

export default PrivateLaunchGate;